/**
 * The single answer to "this element type has no registered renderer".
 *
 * Phase 486 SC#2 / T-486-01 decided it here: warn, and emit a placeholder node
 * that keeps the element addressable, instead of silently dropping the node.
 * Silently returning `null` loses whole blocks and pages with no warning and
 * no trace — the render-coverage gates grep for `data-unknown-type` precisely
 * because a dropped node is otherwise indistinguishable from an empty one.
 *
 * This lives in its own module so every web-lane dispatch site — this
 * package's ElementRenderer plus `@cogo/react-renderer-v2`'s BlockV2 (block
 * root) and AppV2 (page-tree top level) — answers the question from ONE
 * declaration rather than each re-deciding it.
 *
 * The React Native lane cannot import this (DOM `<span>` has no place in a
 * native closure); it mirrors the same answer with RN primitives in
 * `@cogo/react-native-renderer`'s element-renderer, keyed to the same
 * "No renderer for type: <type>" warn text.
 *
 * Called as a plain function — NOT mounted as a component — so the warn fires
 * in the caller's render body exactly where the inline code used to sit, and
 * no extra fiber is introduced.
 */
export function renderUnmappedType(type: string, elementId?: string) {
  console.warn(`No renderer for type: ${type}`)
  return <span data-unknown-type={type} data-cogo-element-id={elementId} />
}
